import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { PHSensorNodeModel } from './PHSensorNodeModel';
import { PHSensorNodeWidget } from './PHSensorNodeWidget';

export class PHSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.PhSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new PHSensorNodeModel();
  }

  nodeUI(event) {
    return <PHSensorNodeWidget engine={this.engine} node={event.model} width={50} height={44} renderedOnMap />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
